import { render, staticRenderFns } from "./authorityModel.vue?vue&type=template&id=64699fc3&scoped=true"
import script from "./authorityModel.vue?vue&type=script&lang=js"
export * from "./authorityModel.vue?vue&type=script&lang=js"
import style0 from "./authorityModel.vue?vue&type=style&index=0&id=64699fc3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64699fc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64699fc3')) {
      api.createRecord('64699fc3', component.options)
    } else {
      api.reload('64699fc3', component.options)
    }
    module.hot.accept("./authorityModel.vue?vue&type=template&id=64699fc3&scoped=true", function () {
      api.rerender('64699fc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/authorityManage/authorityModel.vue"
export default component.exports